import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import CompactLayout from 'src/layouts/compact';

import { rootRoute } from './root';

const MfaResetRequestPage = lazy(
  () => import('src/sections/auth/mfa-reset/mfa-reset-request-view')
);

const MfaResetConfirmPage = lazy(
  () => import('src/sections/auth/mfa-reset/mfa-reset-confirm-view')
);

export const mfaResetRequestRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/request-reset-mfa',
  component: () => (
    <CompactLayout>
      <MfaResetRequestPage />
    </CompactLayout>
  ),
});

export const mfaResetConfirmRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'reset-mfa',
  component: () => (
    <CompactLayout>
      <MfaResetConfirmPage />
    </CompactLayout>
  ),
});
